/**
 * What the Aged care module is showing right now, for AWise (UX review, 17 Oct 2026: the chat had
 * no idea which screen the reader was on, and no client context).
 *
 * A tiny module-level store rather than React context, because the chat lives in App.tsx above
 * every page and only needs to READ this when a message is sent. The screens write it as they
 * mount; the note is plain facts already on screen (a room price, the four numbers, the chosen
 * plan's name) — AWise quotes them and explains them; it never computes from them.
 */
export type AgedCareScreen = 'hub' | 'step-1' | 'step-2' | 'step-3' | 'manual' | 'guide';

interface AgedCareScreenContext {
    screen: AgedCareScreen;
    /** One short paragraph of facts from the screen, already formatted for reading. */
    note: string;
}

let current: AgedCareScreenContext | null = null;
const listeners = new Set<() => void>();

export function setAgedCareScreenContext(next: AgedCareScreenContext | null): void {
    current = next;
    listeners.forEach((l) => l());
}

export function getAgedCareScreenContext(): AgedCareScreenContext | null {
    return current;
}

export function subscribeAgedCareScreenContext(listener: () => void): () => void {
    listeners.add(listener);
    return () => { listeners.delete(listener); };
}
